
import { defineComponent, onMounted, nextTick, inject } from "vue";
import SectionHeader from "@/components/Shared/SectionHeader/SectionHeader.vue";
import { updateActiveLinkOnScroll } from "@/components/FixedNav/animate";
import { ActiveLinkContext } from "@/interfaces/nav";
import { animateExperienceItem } from "@/components/Experience/animate";

export default defineComponent({
  name: "Experience",
  components: {
    SectionHeader,
  },
  setup() {
    const { updateActiveLink } = inject("active-link") as ActiveLinkContext;

    const experienceItems = [
      {
        company: "AAJ EXPRESS INC.",
        role: "Senior Software Engineer",
        duration: "2023 - PRESENT",
      },
      {
        company: "VankWallet",
        role: "Frontend Engineer",
        duration: "2023",
      },
      {
        company: "Go54 (Formerly Whogohost)",
        role: "Frontend Developer",
        duration: "2022 - 2023",
      },
      {
        company: "TNN Africa",
        role: "Frontend Developer",
        duration: "2021 - 2022",
      },
    ];

    onMounted(() => {
      updateActiveLinkOnScroll("#experience", updateActiveLink);
      // animate();
      nextTick(() => {
        document.querySelectorAll(".experience-item").forEach((el) => {
          animateExperienceItem(el as HTMLElement);
        });
      });
    });

    return {
      experienceItems,
    };
  },
});
